<template>
  <div id="pie"
       :style="size"
       style="display: flex;align-items:center;flex-direction: column">
    <p style="color: white;font-size: 26px">日销量分物资</p>
    <e-charts :size="size"
              :options="options" />
  </div>
</template>

<script>
import ECharts from './ECharts'

export default {
  props: {
    theData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ECharts,
  },
  created() {},
  data: function () {
    return {
      year: 2000,
      options: {
        color: [
          '#E75FC3',
          '#FF0099',
          '#8D7FEC',
          '#F87BE2',
          '#F2719A',
          '#FCA4BB',
          '#F59A8F',
          '#5085F2',
          '#FDB301',
          '#F24354',
          '#32D5B9',
          '#F19E34',
          '#9565F4',
          '#0255FD',
          '#7ED3F4',
          '#002E5A',
          '#07D2F9',
          '#FF0099',
          '#8E2DE2',
          '#32D5B9',
        ],
        title: {
          text: '物资',
          left: 'center',
          top: '50%',
          padding: [10, 0],
          textStyle: {
            color: '#ffc72b',
            fontSize: 16,
            align: 'center',
          },
          subtextStyle: {
            color: '#fff',
            fontSize: 12,
            align: 'center',
          },
        },
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            return `${params.name}<br/>净重: ${params.data.value} 吨`
          },
        },
        legend: {
          top: '1%',
          left: 'center',
          textStyle: {
            color: 'white',
          },
        },
        series: [
          {
            type: 'pie',
            radius: ['30%', '67%'], // 数组的第一项是内半径（%），第二项是外半径（%）
            center: ['50%', '55%'],
            avoidLabelOverlap: true,
            itemStyle: {
              borderRadius: 10,
            },

            labelLine: {
              normal: {
                length: 5,
                length2: 8,
                smooth: true,
              },
            },
            data: this.theData,
          },
        ],
        radius: '80%',
      },
      size: {
        width: '100%',
        height: '600px',
      },
    }
  },
}
</script>

<style scoped>
</style>
